module.exports = __webpack_public_path__ + "static/img/cp_4.f0f64b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/cp_4.png
// module id = cSY0
// module chunks = 1